import { createContext, useContext } from 'react'
import { STATUS_PIPELINE, type StatusStep } from '../utils/statusUtils'

interface NewATAValue {
  open: () => void
}
export const NewATAContext = createContext<NewATAValue>({ open: () => {} })
export const useNewATA = () => useContext(NewATAContext)

interface ProjectConfigValue {
  /** Effective status list for the project (custom or seed). */
  statuses: StatusStep[]
  /** Id of the status new ÄTA default to. */
  defaultStatus: string
  /** Status ids hidden from the pipeline. */
  hiddenStatuses: string[]
  setHiddenStatuses: (statuses: string[]) => void
  /** Push a freshly-saved status config into the live app (from settings). */
  setStatusConfig: (cfg: { statuses: StatusStep[]; defaultStatus: string; hidden: string[] }) => void
}
export const ProjectConfigContext = createContext<ProjectConfigValue>({
  statuses: STATUS_PIPELINE,
  defaultStatus: 'upplagd',
  hiddenStatuses: [],
  setHiddenStatuses: () => {},
  setStatusConfig: () => {},
})
export const useProjectConfig = () => useContext(ProjectConfigContext)
